<div>
  @if (badgeConfig | async; as $badgeConfig) {
    @if ($badgeConfig.isVisible) {
      <div
        class="badge"
      [ngClass]="{
        'badge--pulsing': $badgeConfig.pulsing || false,
        'badge--with-content': !!$badgeConfig.content
      }">
        @if (!!$badgeConfig.content) {
          <span [innerText]="$badgeConfig.content"></span>
        }
      </div>
    }
  }
</div>
